import { useTranslation } from 'react-i18next';
import { useGetBConnectInterventionTypes } from '../../../../../../hooks/datarefs';
import { translateType } from '../../../NewIntervention/Steps/utils';
import { RequestRow, displayValue } from './requestRows';

/**
 * Résout le code du type d'intervention en libellé traduit, pour les tables des deux
 * étapes.
 *
 * Le `Number()` est indispensable : l'API renvoie le code en chaîne alors que le
 * référentiel l'expose en nombre. Sans conversion la correspondance échoue toujours et
 * la cellule retombe sur un tiret.
 */
export function useInterventionTypeLabel(): (row: RequestRow) => string {
  const { t } = useTranslation();
  const { data: interventionTypes } = useGetBConnectInterventionTypes();

  return (row) => {
    const type = (interventionTypes ?? []).find(
      (item) => item.Id === Number(row.intervention_type_code)
    );

    return type ? translateType(type.Name, t) : displayValue(null);
  };
}
